module.exports = __webpack_public_path__ + "static/media/descrip7.01ef8cb2.jpg";